import { IconButton } from '@material-ui/core';
import { useState, useEffect } from 'react';
import Tooltip from '@material-ui/core/Tooltip';
import styles from './styles';
import useSignal from 'hooks/useSignal';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import DashboardIcon from '@material-ui/icons/Dashboard';
import Typography from '@material-ui/core/Typography';
import { SET_LAYOUT_TYPE } from 'store/VideoRoom/videoRoomAction';
import { useDispatch, useSelector } from 'react-redux';
const ITEM_HEIGHT = 48;

export default function LayoutButton({ classes, room, layoutSignal }) {
  const localClasses = styles();
  const [layOut, setLayOut] = useState('grid');
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const { sendSignal } = useSignal({ room });
  const dispatch = useDispatch();
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLayOutChange = (layout) => {
    if (room) {
      if (layout === 'active-speaker') {
        room.setLayoutMode('active-speaker');
        setLayOut('active-speaker');
        dispatch({
          type: SET_LAYOUT_TYPE,
          payload: 'active-speaker',
        });
        sendSignal({
          type: 'layout',
          data: { layout: 'active-speaker' },
        });
        setAnchorEl(null);
        sessionStorage.setItem('layout', 'active-speaker');
      } else if (layout === 'screenshare-only') {
        room.setLayoutMode('screenshare-only');
        setLayOut('screenshare-only');
        dispatch({
          type: SET_LAYOUT_TYPE,
          payload: 'screenshare-only',
        });
        sendSignal({
          type: 'layout',
          data: { layout: 'screenshare-only' },
        });
        setAnchorEl(null);
        sessionStorage.setItem('layout', 'screenshare-only');
      } else {
        room.setLayoutMode('grid');
        setLayOut('grid');
        dispatch({
          type: SET_LAYOUT_TYPE,
          payload: 'grid',
        });
        sendSignal({
          type: 'layout',
          data: { layout: 'grid' },
        });
        setAnchorEl(null);
        sessionStorage.setItem('layout', 'grid');
      }
    }
  };

  useEffect(() => {
    if (room) {
      room.setLayoutMode('active-speaker');
      setLayOut('active-speaker');
    }
  }, []);

  useEffect(() => {
    if (layoutSignal) {
      handleLayOutChange(layoutSignal);
    }
  }, [layoutSignal]);
  return (
    <div>
      <Tooltip title='Change Layout'>
        <IconButton
          aria-label='more'
          aria-controls='long-menu'
          aria-haspopup='true'
          className={classes.toolbarButtons}
          onClick={handleClick}
        >
          <DashboardIcon />
        </IconButton>
      </Tooltip>
      <Menu
        id='long-menu'
        anchorEl={anchorEl}
        keepMounted
        open={open}
        onClose={handleClose}
        PaperProps={{
          style: {
            maxHeight: ITEM_HEIGHT * 4.5,
            width: '40ch',
          },
        }}
      >
        <MenuItem
          className={layOut === 'grid' ? localClasses.choosen : null}
          onClick={() => handleLayOutChange('grid')}
        >
          <Typography variant='inherit'>Grid</Typography>
        </MenuItem>
        <MenuItem
          className={layOut === 'active-speaker' ? localClasses.choosen : null}
          onClick={() => handleLayOutChange('active-speaker')}
        >
          <Typography variant='inherit'>Active Speaker</Typography>
        </MenuItem>
        <MenuItem
          className={
            layOut === 'screenshare-only' ? localClasses.choosen : null
          }
          onClick={() => handleLayOutChange('screenshare-only')}
        >
          <Typography variant='inherit'>Screenshare Only</Typography>
        </MenuItem>
      </Menu>
    </div>
  );
}
